import { Component, HostBinding, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { AutocompleteService } from "app/genericForm/service/autocomplete.service";
import { CargandoService } from "app/shared/cargando/cargando.service";
import { debounceTime } from "rxjs/operators";
import { FieldConfig } from "../../field.interface";
@Component({
  selector: "app-autocomplete",
  template: `

        <div class="row" [hidden]="hidden()">
            <mat-form-field class="col-12" [formGroup]="group">
                <input type="text" [placeholder]="field.label" aria-label="Number" matInput [formControlName]="field.name" [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
                    <mat-option *ngFor="let option of filteredOptions" [value]="option">
                    {{option[field.description]}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>

`,
  styles: []
})
export class AutocompleteComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  filteredOptions: any[];
  searching: boolean;
  searchFailed: boolean;
  @HostBinding('class') class = '';

  constructor(
    private autocompleteService: AutocompleteService,
    private cargandoService: CargandoService
  ) { }

  displayFn(value?: any) {
    return value ? value[this.field.description] : "";
  }

  ngOnInit() {
    this.class = this.field.claseGrillaBootstrap;
    this.group.get(this.field.name).valueChanges
      .pipe(debounceTime(500))
      .subscribe(value => {
        if (value != null) {
          this.cargandoService.start(this.field.idSpinner);
          if (value.length >= 1) {
            this.autocompleteService.getListaAutocompleteByUrl(this.field.urlAutocomplete + value).subscribe(response => {
              this.filteredOptions = response;
              this.cargandoService.stop(this.field.idSpinner);
            });
          }
          else {
            this.cargandoService.stop(this.field.idSpinner);
            return null;
          }
        }
      })
  }

  hidden() {
    return this.field.visible === false;
  }
}
